import { addSideEffects } from '@poa/state';
import { fetch, setDates } from './plugin.actions';
import { normalizeDateForBackend } from '../../utils/dates';

addSideEffects(fetch, async (payload, { actions, store, env }) => {
  try {
    const { startDate, endDate } = store.plugin.filters;
    const response = await env.api.plugin.fetchPlugin(startDate.valueOf(), endDate.valueOf());

    actions.pluginActions.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.pluginActions.fetchFailed();
    throw e;
  }
});

addSideEffects(setDates, async (payload, { actions, env, store }) => {
  try {
    const { startDate, endDate } = store.plugin.filters;
    const response = await env.api.plugin.fetchPlugin(
      normalizeDateForBackend(startDate),
      normalizeDateForBackend(endDate)
    );

    actions.pluginActions.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.pluginActions.fetchFailed();
    throw e;
  }
});
